import {connectInfiniteHits} from 'instantsearch.js/es/connectors';
import {sendSearchResultClickedEvent, sendSearchResultThumbClickedEvent} from './algolia.tracking';

const renderCustomInfiniteHits = (renderOptions, isFirstRender) => {
    const {
        hits,
        results,
        widgetParams,
        showMore,
        isLastPage,
    } = renderOptions;
    const loadMoreStatsNode = widgetParams.container.querySelector('#js-load-more__stats');

    if (isFirstRender) {

        const masonryGrid = document.createElement('ul');
        masonryGrid.className = 'masonry-grid';
        masonryGrid.id = 'masonry-grid';
        masonryGrid.setAttribute('data-ng-init', 'wishlist.setListingPageType(true)');
        masonryGrid.setAttribute('data-cy', 'lp_products');

        const nextButton = document.createElement('button');
        nextButton.className = 'btn btn-outline-primary btn-lg btn-load-more';
        nextButton.textContent = widgetParams.translations['algolia.search.list.loadmore'];
        nextButton.addEventListener('click', () => {
            showMore();
        });

        const stats = document.createElement('div');
        stats.className = 'load-more__stats';
        stats.id = 'js-load-more__stats';
        stats.style.display = 'none';

        const buttonWrapper = document.createElement('div');
        buttonWrapper.className = 'load-more__wrapper';
        buttonWrapper.appendChild(stats);
        buttonWrapper.appendChild(nextButton);

        widgetParams.container.appendChild(masonryGrid);
        widgetParams.container.appendChild(buttonWrapper);

        return;
    }

    if (loadMoreStatsNode) {
        if (results?.nbHits) {
            const maxHits = results?.hitsPerPage * (results?.page + 1);
            const currentHits = maxHits > results?.nbHits ? results?.nbHits : maxHits;
            const buttonText = widgetParams.translations['algolia.search.results.hitsOfTotalHits'];

            loadMoreStatsNode.textContent = buttonText.replaceAll('$$currentHits$$', currentHits).replaceAll('$$numberOfHits$$', results?.nbHits);
            loadMoreStatsNode.style.display = 'block';
        } else {
            loadMoreStatsNode.style.display = 'none';
        }
    }

    if (isLastPage) {
        widgetParams.container.querySelector('.btn-load-more').style.display = 'none';
    } else {
        widgetParams.container.querySelector('.btn-load-more').style.display = 'block';
    }

    //Algolia queryID optimisation
    let originalQueryID = '';
    if (document.querySelectorAll('.js-product-id').length > 2) {
        const searchParams = new URL(document.querySelector('.js-product-id').querySelector('a').href).searchParams;
        if (searchParams.has('queryId')) {
            originalQueryID = searchParams.get('queryId')
        }
    }

    widgetParams.container.querySelector('.masonry-grid').innerHTML = `
                    ${hits.map(item => getProductItem(item, widgetParams.translations, originalQueryID)).join('')}`;

    if (window.aa !== undefined) {

        // TODO: refactor, use delegate
        window.algoliaHits = hits;
        [...widgetParams.container.querySelectorAll('.productcell__image-link')].forEach((href, index) => {
            let hit = hits[index];

            href.addEventListener('click', () => {
                sendSearchResultClickedEvent(hit);

            });
        });

        [...widgetParams.container.querySelectorAll('.productcell__color.algolia')].forEach((href, index) => {
            href.addEventListener('click', () => {
                let queryID = href.getAttribute('data-queryID');
                let connectedObjectIds = href.getAttribute('data-connectedObjectIds');
                let position = href.getAttribute('data-position');

                sendSearchResultThumbClickedEvent(queryID, connectedObjectIds, position);
            });
        });
    }
};

const getProductItem = (item, translations, originalQueryID) => {
    //rewrite query id to use the same as on first page
    if (originalQueryID.length > 1) {
        item.__queryID = originalQueryID;
    }

    return `<li class="productcell algolia masonry-grid__item">
                ${getProductBadges(item)}
                <div class="js-product-id" id="pc-${item.code}" data-cy="lp_productCell">
                    ${getProductImage(item)}
                    ${getProductInfo(item, translations)}    
                </div>
                ${getProductWishlist(item, translations)}
            </li>`;
};

const getProductWishlist = (item, translations) => {
    try {
        let angularWishlist = angular.element('#product-grid').scope().wishlist;
        angularWishlist.init(item.baseCode);
    } catch (e) {
        console.error('In SmartEdit no angular');
    }

    let wishlistContainer = document.createElement('div');
    wishlistContainer.innerHTML =
        `<button class="btn-reset product__wishlist-cta product__wishlist-cta--plp algolia"
         data-cy="pdp_wishListBtn"
         data-item-code="${item.baseCode}"
         data-connectedObjectIds="${item.connectedObjectIds}"
         data-objectID="${item.objectID}"
         data-queryID="${item.__queryID}"
         data-aria-add="${translations['algolia.wishlist.ariaLabel.add']}"
         data-aria-remove="${translations['algolia.wishlist.ariaLabel.remove']}"
         aria-label="${translations['algolia.wishlist.ariaLabel.add']}">
            <span class="d-inline-block plp-popover plp-popover-maxsize">
                <svg class="icon icon-wishlist icon-wishlist--empty" data-cy="lp_wishListBtn" focusable="false">
                    <use xlink:href="#icon-wishlist"></use>
                </svg>
                <svg class="icon icon-wishlist icon-wishlist--full ng-hide" focusable="false">
                    <use xlink:href="#icon-wishlist-filled"></use>
                </svg>
            </span>
        </button>`;

    return wishlistContainer.innerHTML;
};

const getProductImage = (item) => {
    return `<figure class="productcell__image">
                            <a class="productcell__image-link" href="${item.pdpUrl}?queryId=${item.__queryID}" title="${item.name}">
                                <picture class="intrinsic intrinsic--productcell">
                                    <img loading="lazy" class="intrinsic__item" src="${item.images}" alt="${item.brand} ${item.name}" title="${item.name}">
                                </picture>
                            </a>
                        </figure>`;
};

const getProductInfo = (item, translations) => {
    return `<div class="productcell__info algolia" data-cy="lp_details">
                <h3 class="mb-0">
                    <span class="productcell__brand text-truncate" data-cy="lp_productVendor">${item.brand}</span>
                    <span class="productcell__name text-truncate" data-cy="lp_productName">${item.name}</span>
                </h3>
                ${getProductPrice(item)}
                ${getProductColors(item, translations)}
            </div>`;
};

const getProductBadges = (item) => {
    const badges = [];
    if (item.badges !== undefined) {
        item.badges.forEach(badge => {
            badges.push(`<div class="badge badge--sm" style="color: ${badge.textColor}; background-color: ${badge.backgroundColor}">${badge.title}</div>`);
        });
    }

    const reducedBadges = badges.reduce((acc, cur) => {
        return `${acc}${cur}`;
    }, '');

    return `
        <div class="position-relative">
            <div class="badges badges--productcell">${reducedBadges}</div>
        </div>`
};

const getProductColors = (item, translations) => {
    let productCellColors = document.createElement('ul');
    productCellColors.className = 'productcell__colors algolia';

    if (item.colorVariants !== undefined) {
        item.colorVariants.map((colorVariant, index) => {
            if (index < 4) {
                productCellColors.appendChild(getColorVariant(colorVariant, index, item, translations));
            }
        });
    }

    return productCellColors.outerHTML;
};

const getColorVariant = (colorVariant, index, item, translations) => {
    const length = item.colorVariants?.length;
    const pdpUrl = item.pdpUrl;
    const name = item.name;
    const brand = item.brand;
    const parentConnectedObjectIds = item.connectedObjectIds;
    const queryID = item.__queryID;
    const position = item.__position;


    const productCellColor = document.createElement('li');
    productCellColor.className = 'productcell__color algolia';

    if (index === 0) {
        productCellColor.className = 'productcell__color productcell__color--active algolia';
    }

    const productCellColorHref = document.createElement('a');
    productCellColorHref.className = 'productcell__color-link';
    productCellColorHref.setAttribute('title', name + ' ' + colorVariant.color.colorTitle);
    productCellColorHref.setAttribute('href', colorVariant.pdpUrl + '?queryId=' + queryID);
    productCellColorHref.setAttribute('data-connectedObjectIds', colorVariant.connectedObjectIds);
    productCellColorHref.setAttribute('data-queryID', queryID);
    productCellColorHref.setAttribute('data-position', position);
    //productCellColorHref.setAttribute('data-code', colorVariant.baseCode);

    if (length > 4) {
        if (index <= 2) {
            productCellColorHref.innerHTML = `<img loading="lazy" alt="${colorVariant?.color?.colorTitle}" class="productcell__color-img" src="${colorVariant.thumbnailUrl}"/>`;
        } else {
            productCellColorHref.setAttribute('title', name);
            productCellColorHref.setAttribute('aria-label', `${length - 3} ${translations['algolia.search.results.wcag.additionalVariants']}`);
            productCellColorHref.setAttribute('href', pdpUrl + '?queryId=' + queryID);
            productCellColorHref.setAttribute('data-connectedObjectIds', parentConnectedObjectIds);
            productCellColorHref.innerHTML = `+${length - 3}`;
            productCellColor.className = 'productcell__color productcell__color--number algolia';
        }
    } else {
        productCellColorHref.innerHTML = `<img loading="lazy" alt="${brand} ${name} ${colorVariant?.color?.colorTitle}" class="productcell__color-img" src="${colorVariant.thumbnailUrl}"/>`;
    }

    productCellColor.appendChild(productCellColorHref);

    return productCellColor;

};

const getProductPrice = (item) => {
    let priceHtml = ``;
    if (item.formattedInsteadPrice === undefined || item.formattedInsteadPrice === '0') {
        priceHtml = `<span class="productcell__price--normal"><span>${item.formattedPrice}</span></span>`;
    } else {
        priceHtml = `<span class="productcell__price--sale">${item.formattedPrice}</span>
                     <s class="productcell__price--strike">${item.formattedInsteadPrice}</s>`;

    }

    if (item.formattedClubPrice !== undefined && item.formattedClubPrice !== '0') {
        priceHtml += `<span class="productcell__price--club--outer"><span class="productcell__price--club">
                        <svg class="icon icon-yourprice"><use xlink:href="#icon-yourprice"></use></svg>
                        ${item.formattedClubPrice}
                    </span></span>`;
    }

    return `<div class="productcell__price">${priceHtml}</div>`;
};

// Create the custom widget
const customInfiniteHits = connectInfiniteHits(
    renderCustomInfiniteHits
);

export {customInfiniteHits};